import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import i18n from 'i18n';
// import { getLanguage } from 'utils/cookies';
import * as termsActions from 'redux/ducks/Terms/TermsDucks';

export const PrivacyPolicy = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const sch = location.search;
  const searchParams = new URLSearchParams(sch);
  const cntryCd = searchParams.get('cntryCd');
  const { trmsCd, privacyPolicy, currentVersion } = useSelector(state => state.terms);
  const [langIdx, setLangIdx] = useState(0);
  const [currentTerm, setCurrentTerm] = useState([]);
  // const langCd = getLanguage();
  useEffect(() => {
    cntryCd ? dispatch(termsActions.getTermsVersionCntryCd(cntryCd)) : dispatch(termsActions.getTermsPolicy());
  }, []);

  useEffect(() => {
    if (trmsCd?.trmsCd) {
      dispatch(termsActions.getPrivacyPolicy({ trmsCd: trmsCd.trmsCd, noSessionPrc: cntryCd ? 'Y' : 'N' }));
    } else if (trmsCd?.errorCode) {
      navigate.replace('/uersapp/error');
    }
  }, [trmsCd]);

  useEffect(() => {
    if (privacyPolicy) {
      setCurrentTerm(privacyPolicy.filter(values => values.trmsVerVal === trmsCd.trmsVerVals[currentVersion]));
    }
  }, [privacyPolicy]);

  const handleOnChageVersion = param => {
    if (currentVersion > -1 && currentVersion < trmsCd.trmsVerVals?.length) {
      let setVersion = currentVersion;
      setVersion = param === 'up' ? currentVersion + 1 : currentVersion - 1;
      dispatch(termsActions.setCurrentVersion(setVersion));
      setCurrentTerm(privacyPolicy.filter(values => values.trmsVerVal === trmsCd.trmsVerVals[setVersion]));
    }
  };

  return (
    <div className="saas-container" style={{ overflow: 'auto' }}>
      <div className="contents-area">
        <div className="sub-wrapper">
          <div className="sub-header">
            <h2 data-lang="ko">{i18n.t('MB_PRIVACY_POLICY')}</h2>
          </div>
          <div className="sub-contents">
            <div className="default-style tou private type02">
              <div className="terms-title">
                <span>Brity Works</span>
                <span className="toggle_area">
                  <button
                    type="button"
                    data-btn-lang="ko"
                    className={`button default ${langIdx === 0 && `current`}`}
                    onClick={() => {
                      setLangIdx(0);
                    }}
                  >
                    <span>{privacyPolicy[0]?.langNm}</span>
                  </button>
                  {privacyPolicy.length > 1 && (
                    <button
                      type="button"
                      data-btn-lang="en"
                      className={`button default ${langIdx === 1 && `current`}`}
                      onClick={() => {
                        setLangIdx(1);
                      }}
                    >
                      <span>{privacyPolicy[1]?.langNm}</span>
                    </button>
                  )}
                </span>
              </div>
              <div className="default-body type02">
                <div className="terms-contents">
                  <div className="terms-box" data-lang="ko">
                    <p className="terms-subtitle">
                      <span className="terms-txt">{currentTerm[langIdx] && currentTerm[langIdx].trmsTtl}</span>
                    </p>

                    <div className="terms-exp">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: currentTerm[langIdx] && currentTerm[langIdx]?.trmsCn,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="btn_area">
                <button
                  type="button"
                  className={`button default goto ${currentVersion === 0 ? 'disabled' : 'abled'}`}
                  disabled={currentVersion === 0}
                  onClick={() => {
                    handleOnChageVersion('down');
                  }}
                >
                  <span className="prev">{i18n.t('BTY_W_T_PREV')}</span>
                </button>
                <button
                  type="button"
                  className={`button default goto ${
                    trmsCd.trmsVerVals?.length - 1 === currentVersion ? 'disabled' : 'abled'
                  }`}
                  disabled={trmsCd.trmsVerVals?.length - 1 === currentVersion}
                  onClick={() => {
                    handleOnChageVersion('up');
                  }}
                >
                  <span className="next">{i18n.t('BTY_W_T_NEXT')}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

PrivacyPolicy.propTypes = {};
PrivacyPolicy.defaultProps = {};

export default PrivacyPolicy;
